<template>
  <a-table rowKey="id" :columns="innerColumns" :data-source="table.tableDataSource" :loading="table.tableLoading" :pagination="false">
    <div class="course-name" slot="name" :title="text.name" slot-scope="text">
      <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0" />
      <img :src="text.icon | filterUrl" alt="" />
      <span>{{ text.name }}</span>
    </div>
    <div slot="courseType" slot-scope="text">
      <span v-if="text === 1">测评课程</span>
      <span v-if="text === 2">训练课程</span>
      <span v-if="text === 3">活动课程</span>
    </div>
    <div slot="price" slot-scope="text" style="color: red">￥{{ text }}</div>
    <div slot="innerAction" slot-scope="text" class="action">
      <!--            <a @click="editCourse(text, true)"
               v-permission="`Content.Course.CourseDetail`"
               v-if="[1, 2].includes(Number($route.query.type))">
                详情
            </a>-->
      <a @click="courseHour(text)" v-permission="`/course/manage/CourseChildren`"> 课时 </a>
      <a-dropdown>
        <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
          更多
          <a-icon type="down" />
        </a>
        <!--
        seriesInfo.status
        0:录入中,
        1:待审核,
        2:审核通过
        3:审核失败，
        4:已上线
         -->
        <a-menu slot="overlay">
          <a-menu-item v-if="seriesInfo.status === 1" v-permission="`/course/manage/CourseSeting`">
            <a @click="editCourse(text, true)">课程详情</a>
          </a-menu-item>
          <a-menu-item v-if="seriesInfo.status !== 1" v-permission="`/course/manage/CourseSeting`">
            <a @click="editCourse(text)">编辑课程</a>
          </a-menu-item>
          <a-menu-item v-permission="`/course/manage/CourseReport`">
            <a @click="courseReport(text)">课程报告</a>
          </a-menu-item>
          <a-menu-item v-if="![1, 4].includes(seriesInfo.status) || $checkAuth(['Content.Course.Ignore'])" v-permission="`/course/manage/CourseSeting`">
            <a @click="copyCourse(text)">复制课程</a>
          </a-menu-item>
          <a-menu-item v-if="[0, 3].includes(seriesInfo.status) || $checkAuth(['Content.Course.Ignore'])" v-permission="authMap.CourseRemove">
            <a @click="removeCourse(text)" class="red">移除课程</a>
          </a-menu-item>
          <a-menu-item v-if="![1, 2].includes(seriesInfo.status) || $checkAuth(['Content.Course.Ignore'])" v-permission="authMap.CourseDelete">
            <a @click="delCourse(text)" style="color: red">删除课程</a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </a-table>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const innerColumns = [
  {
    title: '课程名称',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '适用学段',
    dataIndex: 'period',
    width: 100,
  },
  {
    title: '类型',
    dataIndex: 'courseType',
    width: 100,
    scopedSlots: { customRender: 'courseType' },
  },
  {
    title: '课时数',
    width: 100,
    dataIndex: 'courseSessionCount',
  },
  {
    title: '报告数',
    width: 100,
    dataIndex: 'reportCount',
  },
  {
    title: '价格',
    dataIndex: 'price',
    width: 100,
    scopedSlots: { customRender: 'price' },
  },
  {
    title: '操作',
    width: 150,
    scopedSlots: { customRender: 'innerAction' },
  },
]
export default {
  name: 'CourseTable',
  props: {
    seriesInfo: Object,
    courseName: String,
    authMap: {
      default: () => ({}),
      type: Object,
    },
  },
  data() {
    return {
      innerColumns,
      table: tableRelevant.call(this),
      courseSeriesId: '',
    }
  },
  mounted() {},
  methods: {
    toRecommend(record) {
      this.$store.commit('course/setSeriesInfo', this.seriesInfo)
      this.$store.commit('course/setCourseInfo', record)
      console.log(record, '--recordrecord')
      this.$router.push({ path: '/course/manage/recommendPage' })
    },
    getCourseList(id) {
      if (id) {
        this.courseSeriesId = id
      }
      this.table.tableLoading = true
      this.$http.CourseResource.courseAll({ CourseSeriesId: id || this.courseSeriesId, courseName: this.courseName })
        .then((res) => {
          this.table.tableDataSource = res.data
        })
        .finally(() => {
          this.table.tableLoading = false
        })
    },
    courseHour(record) {
      this.$store.commit('course/setSeriesInfo', this.seriesInfo)
      this.$store.commit('course/setCourseInfo', record)
      sessionStorage.setItem('courseItem', JSON.stringify(record))
      sessionStorage.setItem('currentId', record.id)
      sessionStorage.setItem('currentCourseName', record.name)
      this.$router.push({
        path: '/course/manage/CourseChildren',
        query: {
          type: 'edit',
          name: '课时列表',
          id: record.id,
          fullPath: window.encodeURIComponent(this.$route.fullPath),
        },
      })
    },
    editCourse(val, look) {
      const SeriesInfo = this.seriesInfo
      if (look) {
        SeriesInfo.status = 1
      }
      this.$store.commit('course/setSeriesInfo', SeriesInfo)
      this.$store.commit('course/setCourseInfo', val)
      this.$router.push({
        path: '/course/manage/CourseSeting',
        query: {
          name: '基本设置',
          fullPath: window.encodeURIComponent(this.$route.fullPath),
        },
      })
    },
    removeCourse(val) {
      this.$confirm({
        title: '确认移除课程',
        centered: true,
        onOk: () => {
          this.table.tableLoading = true
          this.$http.CourseResource.courseImport({ courseIds: [val.id] })
            .then((res) => {
              this.$message.success(res.message)
              this.getCourseList()
            })
            .finally(() => {
              this.table.tableLoading = false
            })
        },
      })
    },
    delCourse(val) {
      const confirm = (title, callback, type) => {
        return new Promise((resolve) => {
          this.$confirm({
            title,
            width: 520,
            content: (h) => typeof callback === 'function' && callback(h),
            centered: true,
            okType: type,
            onOk: () => {
              resolve()
            },
          })
        })
      }
      const courseDelete = (id) => {
        this.table.tableLoading = true
        this.$http.CourseResource.courseDelete(id)
          .then((res) => {
            this.$message.success(res.message)
            this.$store.dispatch('course/setCourseStatus', this.seriesInfo)
            this.$emit('updatePageList', 1)
            this.getCourseList()
          })
          .finally(() => {
            this.table.tableLoading = false
          })
      }
      const courseCheckDeleted = () => {
        const form = new FormData()
        form.append('id', val.id)
        this.table.tableLoading = true
        this.$http.Course.courseCheckDeleted(form)
          .then((res) => {
            if (res.isSuccess) {
              courseDelete(val.id)
            } else {
              confirm(
                '课程使用中',
                function (createElement) {
                  return createElement('div', {}, [
                    createElement('p', {}, '系列下课程已有用户正在使用，删除后所有课程将无法使用并被自动从用户账号中删除，请确认已做好相关用户的提前告知与确认'),
                    createElement('p', { style: { color: 'red' } }, '是否继续删除?'),
                  ])
                },
                'danger'
              ).then(() => {
                courseDelete(val.id)
              })
            }
          })
          .catch(() => {
            this.table.tableLoading = false
          })
      }

      confirm('确认删除？', null, 'danger').then(() => {
        if (this.seriesInfo.enabled) {
          confirm(
            '课程启用中',
            function (createElement) {
              return createElement('div', {}, [
                createElement('p', {}, '系列下课程正在启用中，删除后会所有用户将无法再看到相关课程'),
                createElement('p', { style: { color: '#faad14' } }, '是否继续删除?'),
              ])
            },
            'danger'
          ).then(() => {
            courseCheckDeleted()
          })
        } else {
          courseCheckDeleted()
        }
      })
    },
    copyCourse(val) {
      const form = new FormData()
      form.append('id', val.id)
      this.table.tableLoading = true
      this.$http.CourseResource.courseCopy(form)
        .then((res) => {
          this.$message.success(res.message)
          this.$store.commit('course/setSeriesInfo', this.seriesInfo)
          this.$store.commit('course/setCourseInfo', { ...val, id: res.data, name: undefined })
          this.$router.push({
            path: '/course/manage/CourseSeting',
            query: {
              name: '基本设置',
              fullPath: window.encodeURIComponent(this.$route.fullPath),
            },
          })
        })
        .finally(() => {
          this.table.tableLoading = false
        })
    },
    courseReport(val) {
      this.$store.commit('course/setSeriesInfo', this.seriesInfo)
      this.$store.commit('course/setCourseInfo', val)
      sessionStorage.setItem('courseItem', JSON.stringify(val))
      sessionStorage.setItem('currentId', val.id)
      sessionStorage.setItem('currentName', val.name)
      this.$router.push({
        path: '/course/manage/CourseReport',
        query: {
          type: 'edit',
          name: '课程报告',
          courseType: val.courseType,
          fullPath: window.encodeURIComponent(this.$route.fullPath),
        },
      })
    },
  },
}
</script>

<style scoped>
.course-name {
  display: flex;
  align-items: center;
}

.course-name span {
  /*white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;*/
  flex-grow: 2;
}

.course-name img {
  width: 25px;
  height: 25px;
  object-fit: contain;
  margin-right: 5px;
  flex-shrink: 0;
}
.table_icon {
  color: #ff9904;
  font-size: 24px;
  margin-right: 5px;
}
.disabled {
  color: #d6d5d5;
  pointer-events: none;
}
</style>
